import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import './add-bin-modal';

export class AddBinButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
      binsHref: { type: String, attribute: false },
      addBinAction: { type: Object, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-icon {
        margin-right: .25em;
      }
    `];
  }

  render() {
    return html`
      <lit-entity .href="${this.binsHref}" @update="${this._onUpdateBins}"></lit-entity>
      ${renderIf(this.addBinAction, () => html`
      <button class="button button--contained" @click="${this._onClick}">
        <bn-icon name="fal fa-plus"></bn-icon> Add
      </button>
      
      <add-bin-modal .href="${this.href}" ?hide="${!this.showModal}" @close="${() => this.showModal = false}"
        @response="${({ detail }) => this.dispatchEvent(new CustomEvent('response', { detail, bubbles: true, composed: true }))}">
      </add-bin-modal>
      `)}
    `;
  }

  _onUpdateBins(e) {
    const { entity } = e.detail;
    this.addBinAction = entity && entity.getAction('add-bin');
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }

  async _entityChanged(entity) {
    super._entityChanged(entity);
    this.binsHref = this.getHref('https://api.binsentry.com/rel/v2/bins');
  }
}

window.customElements.define('add-bin-button', AddBinButton);
